import React, { Component } from 'react';  
import { Route } from 'react-router-dom';  
import WebHeader from './header';
import WebFooter from './footer';
import cn from 'classnames'
const LoginLayout = ({ children }) =>  {   

  return (                   
    <div >
      <WebHeader />  
      <div className={cn("static-container",children.props.match.isExact ? "is-web-layout" : "is-panel")}  >
        {children}
      </div>
      <WebFooter />                                       
    </div>  
  );  
}
  const LoginLayoutRoute = ({component: Component, ...rest}) => {  
    return (  
      <Route {...rest} render={matchProps => (  
        <LoginLayout>  
            <Component {...matchProps} />  
        </LoginLayout>  
      )} />  
    )  
  };  
  
export default LoginLayoutRoute;